// TadsCPMBoostProvider.ts
import type {
  BoostProvider,
  BoostTask,
} from '../pages/Tasks/adapters/sponsors/boost/types/boost';

type TaskResult = 'success' | 'user_cancelled' | 'ads_not_found';

const EVENT_SHOW = 'tads_cpm_show';

let pendingResolve: ((r: TaskResult) => void) | null = null;

export function resolveTadsCpm(result: TaskResult) {
  const r = pendingResolve;
  pendingResolve = null;
  if (r) r(result);
}

export function isTadsCpmPending() {
  return !!pendingResolve;
}

export class TadsCPMBoostProvider implements BoostProvider {
  private isTaskInProgress = false;

  getName(): string {
    return 'tads_cpm';
  }

  async getAvailableTasks(): Promise<BoostTask[]> {
    if (this.isTaskInProgress) return [];

    return [
      {
        id: 'tads_cpm_fullscreen',
        title: 'Показать рекламу',
        description: 'Просмотр рекламы TADS CPM',
        provider: this.getName(),
        onClick: () => this.startTask('tads_cpm_fullscreen'),
      },
    ];
  }

  async startTask(_taskId: string | number): Promise<TaskResult> {
    if (this.isTaskInProgress) return 'ads_not_found';
    if (isTadsCpmPending()) return 'ads_not_found';

    this.isTaskInProgress = true;

    return new Promise<TaskResult>((resolve) => {
      pendingResolve = (result) => {
        this.isTaskInProgress = false;
        resolve(result);
      };

      window.dispatchEvent(new Event(EVENT_SHOW));
    });
  }

  resetError(): void {
    if (this.isTaskInProgress && pendingResolve) {
      this.isTaskInProgress = false;
      resolveTadsCpm('user_cancelled');
    }
  }
}

export const TADS_CPM_EVENT_SHOW = EVENT_SHOW;
